<div class="fixed top-0 right-0 m-1 p-3 z-50">
  @for (toast of toasts | async; track $index) {
    <toast [message]="toast.message" [type]="toast.type" (closeToast)="closeToast(toast)"/>
  }
</div>
